import {ENVIRONMENT_DEVARANA} from "./AppConstants.js";
import AppConfig from "./AppConfig.js";

// import DateTimeUtil from "../utils/DateTimeUtil";

class AppConfigDevarana {

  static loadConfig = () => {
    AppConfig.sCurrentConfigDebugLabel = ENVIRONMENT_DEVARANA;
    AppConfig.aEntreeDagIDEALKortingExternalID = 854;
    AppConfig.aEntreeAvondExternalIDs = [5];

    AppConfig.iNrOfActieArrangementCatThatShouldBeHidden = 9;
    AppConfig.iNoDinnerUntilAfterThisTime = 1700;

    // Geen dinerreserveringen meer bij Devarana
    AppConfig.bIsDinnerTimeSelectionEnabled = false;

    // ENTREES
    AppConfig.aNonActieEntreeExternalIDs = [1, 3, 5, 332]; // main entrees -  moet overeen moet komen met corresponderende PHP array
    AppConfig.iDefaultEntreeID = 1; // als er geen product in de order staat wordt deze 'hele dag toegang' entree als default toegevoegd; bij TB is dat 1
    AppConfig.aEntreeOchtendExternalIDs = []; // moeten ook gewoon in aNonActieEntreeExternalIDs staan -  soesterberg had aanvankelijk geen ochtendentree
    AppConfig.iDefaultEntreeOchtendClosingTime = 1400; // bijv 1400 laatst mogelijke vertrektijd; vanaf 1401 en later zal dan geblokkeerd worden
    AppConfig.iEntree2uurExternalID = 3; // moeten ook gewoon in aNonActieEntreeExternalIDs staan
    AppConfig.aEntreeDagIDEALKortingExternalID = 854; //ID welke geboekt moet worden als mensen met iDEAL betalen bij een dagentree

    // HORECA
    AppConfig.iDinnerProductID = 77;

    //GIFTCARDS
    AppConfig.iMaxRedeemableGiftcards = 4;

    //BADENKAARTEN
    AppConfig.iMaxRedeemableBadenkaarts = 4;

    AppConfig.iNrOfActieArrangementCatThatShouldBeHidden = 7;

    AppConfig.aDatesWithAlternativeTimes = [ // wordt in de kalender lichtbruin weergegeven

    ];

    AppConfig.sTextTimeNormalEntreeFirstArrival = '11:00';
    AppConfig.sTextTimeNormalEntreeLastDeparture = '22:00';
    AppConfig.sTextTimeAvondEntreeFirstArrival = '17:00';

    AppConfig.aTimeConfig = {
      day0: { // ZONDAG
        iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1100, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 2000, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      day1: { // MAANDAG
        iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1100, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 2000, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      day2: { // DINSDAG
        iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1100, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 2000, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      day3: { // WOENSDAG
        iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1100, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 2000, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      day4: { // DONDERDAG
        iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1100, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 2000, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      day5: { // VRIJDAG
        iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1100, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 2000, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1700, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      day6: { // ZATERDAG
        iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1100, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 2000, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      daySpecial1: { // Kerstavond (24 DEC)
        iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1100, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 2000, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      daySpecial2: { // Oudejaarsavond (31 DEC)
        iDefaultOpeningTimeSauna: 1100, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1100, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 1700, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 1800 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      }
    };
  };

  static aAlternateProductPricesDevarana = [ // zorg dat regels voor specifieke data altijd lager in dit rijtje staan dan 'weekend' zodat specifieke regels de weekendregels overrulen
    { // Devarana dag entree
      iID: 999999,
      aRules: [
        {
          iPrice: 4950,
          sDate: 'weekend'
        },
        // Herfst
        {
          iPrice: 4950,
          sDate: '21-10-2024'
        }
      ]
    }
  ];
}

export default AppConfigDevarana;